import {i18n} from '@/plugins/i18n';
import {walletTransactionTypeStr, walletTransactionTypeVariant} from "@/constants/walletTransactionType";
import {walletTransactionStatusStr, walletTransactionStatusVariant, walletTransactionStatus} from "@/constants/walletTransactionStatus";
import {bankIdStr, bankId} from "@/constants/bankId";

export default [
    {
        field: 'check',
        sortable: false,
        title: i18n.t('label.identifier'),
        type: 'number',
        selector: {
            class: 'kt-checkbox--solid'
        },
    },
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('label.amount_rial'),
        sortable: true,
        template: row => {
            return `<span dir="ltr">${row.amount}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: true,
        template: row => {
            return `
                <span class="badge badge-${walletTransactionStatusVariant(row.status, (row.charge_rev_id !== ''))}">
                    ${walletTransactionStatusStr.get(row.status) + ((row.charge_rev_id !== '') ? ' (' + i18n.t('label.reversal') + ')' : '')}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'wallet',
        title: i18n.t('label.wallet'),
        sortable: false,
        template: row => {
            return `<span>${row.wallet.title}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'user',
        title: i18n.t('label.fullname'),
        sortable: false,
        template: row => {
            return `<span><a href="/users/${row.wallet.user_hashid}/details" target="_blank">${row.wallet.user_name}</a></span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'wage',
        title: i18n.t('label.wage'),
        sortable: false,
        template: row => {
            return `<span dir="ltr">${row.wage}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'bank',
        title: i18n.t('label.bank'),
        sortable: false,
        template: row => {
            if (row.bank !== '-') {
                if (row.destination_bank !== '-') {
                    return `<span>${bankIdStr.get(row.bank)} به ${bankIdStr.get(row.destination_bank)}</span>`;
                }

                return `<span>${bankIdStr.get(row.bank)}</span>`;
            }

            return '<span>-</span>';
        },
        textAlign: 'center',
    },
    {
        field: 'source_account_number',
        title: i18n.t('label.source_account_number'),
        sortable: false,
        template: row => {
            if (row.source_account_number === '' || row.source_account_number === null || row.source_account_number === undefined) {
                return '<span>-</span>';
            }

            if (row.bank === bankId.saman) {
                return `<span>${row.source_account_number.slice(0, 9)}</span>`;
            }

            return `<span>${row.source_account_number.slice(-4)}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'payment_date',
        title: i18n.t('label.payment_date'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'type',
        title: i18n.t('label.type'),
        sortable: true,
        template: row => {
            return `
                    <a class="badge badge-${walletTransactionTypeVariant(row.type)} text-white" 
                        data-toggle="tooltip" 
                        data-placement="top" 
                        title="${walletTransactionTypeStr.get(row.type)}"
                    >
                        ${walletTransactionTypeStr.get(row.type)}
                    </a>
                `;
        },
        textAlign: 'center',
    },
]
